((root) => {
  'use strict';
  const whole = value => Number.isSafeInteger(value) && value >= 0;
  const fail = code => ({ok: false, code});
  const check = (cart, allowed) => {
    if (!cart || !Array.isArray(cart.items) || !(allowed instanceof Set)) return fail('INVALID');
    const lines = cart.items.filter(item => allowed.has(String(item.variant_id)));
    if (!lines.length) return {ok: true, count: 0};
    if (cart.currency !== 'INR') return fail('CURRENCY');
    let count = 0;
    for (const line of lines) {
      if (!whole(line.quantity) || !line.quantity) return fail('INVALID');
      count += line.quantity;
      if (line.gift_card || line.selling_plan_allocation) return fail('INELIGIBLE');
      if (line.original_price !== 38900 || line.original_line_price !== line.quantity * 38900) return fail('PRICE');
    }
    if (count > 3) return fail('LIMIT');
    if (!Array.isArray(cart.cart_level_discount_applications)) return fail('INVALID');
    if (cart.cart_level_discount_applications.some(discount => discount.target_type !== 'shipping_line' && discount.total_allocated_amount !== 0)) return fail('DISCOUNT');
    let paid = 0;
    for (const line of lines) {
      if (!whole(line.final_line_price) || !Array.isArray(line.line_level_discount_allocations)) return fail('INVALID');
      let allocated = 0;
      for (const discount of line.line_level_discount_allocations) {
        if (!whole(discount.amount)) return fail('INVALID');
        if (discount.amount && (count !== 3 || discount.discount_application?.title !== 'FAIMLY Trial 3-Pack Offer' || discount.discount_application?.type !== 'automatic')) return fail('DISCOUNT');
        allocated += discount.amount;
      }
      const expected = count === 3 ? line.quantity * 5600 : 0;
      if (allocated !== expected || line.final_line_price !== line.original_line_price - expected) return fail('DISCOUNT');
      paid += line.final_line_price;
    }
    if (paid !== ({1:38900, 2:77800, 3:99900})[count]) return fail('PRICE');
    return {ok: true, count, paid};
  };
  const api = Object.freeze({check});
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FFTrialCartPolicy = api;
})(typeof window === 'undefined' ? {} : window);
